import { useSelector } from 'react-redux'
import useAdditionalSaleFormData from '../../Components/AdditionalSales/useAdditionalSaleFormData'
import { selectAdditionalSaleDataByName } from '../SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'
import useTabBar from '../useTabBar'

const useTelecomContractRelatedScript = () => {
  const { retrieveProductsListOfSale } = useAdditionalSaleFormData()
  let telecomContractOpened = false
  const { openedContracts, existingContracts } = useTabBar()
  if (openedContracts && openedContracts.length > 0) {
    openedContracts.forEach(element => {
      for (const [, contract] of Object.entries(existingContracts)) {
        if (contract.id === element) {
          if (!telecomContractOpened) {
            telecomContractOpened = contract.type === 'telecom'
          }
          break
        }
      }
    })
  }
  const { t } = useTranslation()

  const retrieveMaxCreditsOfProducts = products => {
    return products.reduce((max, product) => {
      return (product.credits?.credits || 0) > (max.credits?.credits || 0) ? product : max
    }, products[0])
  }
  // Protected
  const productListLeadProtected = retrieveProductsListOfSale('leadProtected')
  const productWithHighestCreditsProtected = retrieveMaxCreditsOfProducts(productListLeadProtected)
  const currentLeadProtectedData = useSelector(selectAdditionalSaleDataByName('leadProtected'))
  const protectedLeadSold = currentLeadProtectedData?.zohoContractDetailId?.length > 0

  // Lead Sat
  const productListLeadTelecomSat = retrieveProductsListOfSale('leadTelecomSat')
  const productWithHighestCreditsTelecomSat = retrieveMaxCreditsOfProducts(productListLeadTelecomSat)
  const currentLeadTelecomSatData = useSelector(selectAdditionalSaleDataByName('leadTelecomSat'))
  const leadTelecomSatSold = currentLeadTelecomSatData?.zohoContractDetailId?.length > 0

  const telecomScripts = {}
  if (telecomContractOpened === true) {
    if (productListLeadProtected.length > 0) {
      telecomScripts.leadProtected = {
        name: 'leadProtected',
        title: 'Protected',
        description: t('subscriptionForm:credit_booster.protected'),
        credits: productWithHighestCreditsProtected?.credits?.credits || null,
        sold: protectedLeadSold,
        icon: 'sales-leadProtected',
      }
    }
    if (productListLeadTelecomSat.length > 0) {
      telecomScripts.leadTelecomSat = {
        name: 'leadTelecomSat',
        title: 'Lead Sat',
        description: t('subscriptionForm:credit_booster.leadTelecomSat'),
        credits: productWithHighestCreditsTelecomSat?.credits?.credits || null,
        sold: leadTelecomSatSold,
        icon: 'sales-telecomSat',
      }
    }
  }
  return {
    telecomScripts,
  }
}

export default useTelecomContractRelatedScript
